import React from "react"
import localforage from "localforage"
import { render } from "react-dom"
import { injectGlobal } from "styled-components"
import { Provider as RebassProvider } from "rebass"
import { loadProgressBar } from "axios-progress-bar"
import "axios-progress-bar/dist/nprogress.css"
import "react-select/dist/react-select.css"
import App from "./App"
import "./globalStyle"

import registerServiceWorker from "./registerServiceWorker"
import LanguageProvider from "./LanguageProvider"
import { translationMessages } from "./i18n"

loadProgressBar()

// eslint-disable-next-line
injectGlobal`
  * { box-sizing: border-box; }
  body { margin: 0; }
`

// eslint-disable-next-line
export const DataContext = React.createContext("data")

async function initDataFromLocal() {
  const data = (await localforage.getItem("data")) || []
  render(
    <DataContext.Provider value={data}>
      <RebassProvider>
        <LanguageProvider messages={translationMessages}>
          <App />
        </LanguageProvider>
      </RebassProvider>
    </DataContext.Provider>,
    document.getElementById("root")
  )
}

initDataFromLocal()

if (module.hot) {
  module.hot.accept()
}
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js